import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from '../../shared.module';

@Component({
  selector: 'app-filtro',
  templateUrl: './filtro.component.html',
  styleUrl: './filtro.component.scss'
})
export class FiltroComponent {
  @Input() title: string = 'Filtros';
  @Input() searchButtonText: string = 'Pesquisar';
  @Input() clearButtonText: string = 'Limpar';
  @Input() filtroAberto: boolean = false;

  @Output() onSearch = new EventEmitter<any>();
  @Output() onClear = new EventEmitter<void>();
  @Output() onToggle = new EventEmitter<boolean>();

  toggleFiltro(): void {
    this.filtroAberto = !this.filtroAberto;
    this.onToggle.emit(this.filtroAberto);
  }

  aplicarFiltro(): void {
    this.onSearch.emit();
    this.toggleFiltro();
  }

  limparFiltro(): void {
    this.onClear.emit();
  }
}
